export default "__VITE_ASSET__C1Dr8Jj1__"